import { render, staticRenderFns } from "./main.vue?vue&type=template&id=77dca1da&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=77dca1da&prod&scoped=true&lang=scss"
import style1 from "./main.vue?vue&type=style&index=1&id=77dca1da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dca1da",
  null
  
)

export default component.exports